export default "__VITE_PUBLIC_ASSET__ece975e6__"